import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { ClicFpCodeSelect } from './ClicFpCodeSelect'
import { useClicFpCodeField } from './useClicFpCodeField'

export const ClicFpCodeFields: React.FC = () => {
  const fpCodes = useClicFpCodeField('create')

  return (
    <Row>
      <Col>
        <Form.Label>FP Codes</Form.Label>
        <ClicFpCodeSelect {...fpCodes} />
      </Col>
    </Row>
  )
}
